let city = [
    {
    "value": "110000",
    "label": "北京市",
    "children": [
        {
            "province": "北京市",
            "label": "北京市",
            "value": "110100"
        }
    ]},
    {
    "value": "120000",
    "label": "天津市",
    "children": [
        {
            "province": "天津市",
            "label": "天津市",
            "value": "120100"
        }
    ]},
    {
    "value": "130000",
    "label": "河北省",
    "children": [
        {
            "province": "河北省",
            "label": "石家庄市",
            "value": "130100"
        },
        {
            "province": "河北省",
            "label": "唐山市",
            "value": "130200"
        },
        {
            "province": "河北省",
            "label": "秦皇岛市",
            "value": "130300"
        },
        {
            "province": "河北省",
            "label": "邯郸市",
            "value": "130400"
        },
        {
            "province": "河北省",
            "label": "邢台市",
            "value": "130500"
        },
        {
            "province": "河北省",
            "label": "保定市",
            "value": "130600"
        },
        {
            "province": "河北省",
            "label": "张家口市",
            "value": "130700"
        },
        {
            "province": "河北省",
            "label": "承德市",
            "value": "130800"
        },
        {
            "province": "河北省",
            "label": "沧州市",
            "value": "130900"
        },
        {
            "province": "河北省",
            "label": "廊坊市",
            "value": "131000"
        },
        {
            "province": "河北省",
            "label": "衡水市",
            "value": "131100"
        },
        {
            "province": "河北省",
            "label": "省直辖县级行政区划",
            "value": "139000"
        }
    ]},
    {
    "value": "140000",
    "label": "山西省",
    "children": [
        {
            "province": "山西省",
            "label": "太原市",
            "value": "140100"
        },
        {
            "province": "山西省",
            "label": "大同市",
            "value": "140200"
        },
        {
            "province": "山西省",
            "label": "阳泉市",
            "value": "140300"
        },
        {
            "province": "山西省",
            "label": "长治市",
            "value": "140400"
        },
        {
            "province": "山西省",
            "label": "晋城市",
            "value": "140500"
        },
        {
            "province": "山西省",
            "label": "朔州市",
            "value": "140600"
        },
        {
            "province": "山西省",
            "label": "晋中市",
            "value": "140700"
        },
        {
            "province": "山西省",
            "label": "运城市",
            "value": "140800"
        },
        {
            "province": "山西省",
            "label": "忻州市",
            "value": "140900"
        },
        {
            "province": "山西省",
            "label": "临汾市",
            "value": "141000"
        },
        {
            "province": "山西省",
            "label": "吕梁市",
            "value": "141100"
        }
    ]},
    {
    "value": "150000",
    "label": "内蒙古自治区",
    "children": [
        {
            "province": "内蒙古自治区",
            "label": "呼和浩特市",
            "value": "150100"
        },
        {
            "province": "内蒙古自治区",
            "label": "包头市",
            "value": "150200"
        },
        {
            "province": "内蒙古自治区",
            "label": "乌海市",
            "value": "150300"
        },
        {
            "province": "内蒙古自治区",
            "label": "赤峰市",
            "value": "150400"
        },
        {
            "province": "内蒙古自治区",
            "label": "通辽市",
            "value": "150500"
        },
        {
            "province": "内蒙古自治区",
            "label": "鄂尔多斯市",
            "value": "150600"
        },
        {
            "province": "内蒙古自治区",
            "label": "呼伦贝尔市",
            "value": "150700"
        },
        {
            "province": "内蒙古自治区",
            "label": "巴彦淖尔市",
            "value": "150800"
        },
        {
            "province": "内蒙古自治区",
            "label": "乌兰察布市",
            "value": "150900"
        },
        {
            "province": "内蒙古自治区",
            "label": "兴安盟",
            "value": "152200"
        },
        {
            "province": "内蒙古自治区",
            "label": "锡林郭勒盟",
            "value": "152500"
        },
        {
            "province": "内蒙古自治区",
            "label": "阿拉善盟",
            "value": "152900"
        }
    ]},
    {
    "value": "210000",
    "label": "辽宁省",
    "children": [
        {
            "province": "辽宁省",
            "label": "沈阳市",
            "value": "210100"
        },
        {
            "province": "辽宁省",
            "label": "大连市",
            "value": "210200"
        },
        {
            "province": "辽宁省",
            "label": "鞍山市",
            "value": "210300"
        },
        {
            "province": "辽宁省",
            "label": "抚顺市",
            "value": "210400"
        },
        {
            "province": "辽宁省",
            "label": "本溪市",
            "value": "210500"
        },
        {
            "province": "辽宁省",
            "label": "丹东市",
            "value": "210600"
        },
        {
            "province": "辽宁省",
            "label": "锦州市",
            "value": "210700"
        },
        {
            "province": "辽宁省",
            "label": "营口市",
            "value": "210800"
        },
        {
            "province": "辽宁省",
            "label": "阜新市",
            "value": "210900"
        },
        {
            "province": "辽宁省",
            "label": "辽阳市",
            "value": "211000"
        },
        {
            "province": "辽宁省",
            "label": "盘锦市",
            "value": "211100"
        },
        {
            "province": "辽宁省",
            "label": "铁岭市",
            "value": "211200"
        },
        {
            "province": "辽宁省",
            "label": "朝阳市",
            "value": "211300"
        },
        {
            "province": "辽宁省",
            "label": "葫芦岛市",
            "value": "211400"
        }
    ]},
    {
    "value": "220000",
    "label": "吉林省",
    "children": [
        {
            "province": "吉林省",
            "label": "长春市",
            "value": "220100"
        },
        {
            "province": "吉林省",
            "label": "吉林市",
            "value": "220200"
        },
        {
            "province": "吉林省",
            "label": "四平市",
            "value": "220300"
        },
        {
            "province": "吉林省",
            "label": "辽源市",
            "value": "220400"
        },
        {
            "province": "吉林省",
            "label": "通化市",
            "value": "220500"
        },
        {
            "province": "吉林省",
            "label": "白山市",
            "value": "220600"
        },
        {
            "province": "吉林省",
            "label": "松原市",
            "value": "220700"
        },
        {
            "province": "吉林省",
            "label": "白城市",
            "value": "220800"
        },
        {
            "province": "吉林省",
            "label": "延边朝鲜族自治州",
            "value": "222400"
        }
    ]},
    {
    "value": "230000",
    "label": "黑龙江省",
    "children": [
        {
            "province": "黑龙江省",
            "label": "哈尔滨市",
            "value": "230100"
        },
        {
            "province": "黑龙江省",
            "label": "齐齐哈尔市",
            "value": "230200"
        },
        {
            "province": "黑龙江省",
            "label": "鸡西市",
            "value": "230300"
        },
        {
            "province": "黑龙江省",
            "label": "鹤岗市",
            "value": "230400"
        },
        {
            "province": "黑龙江省",
            "label": "双鸭山市",
            "value": "230500"
        },
        {
            "province": "黑龙江省",
            "label": "大庆市",
            "value": "230600"
        },
        {
            "province": "黑龙江省",
            "label": "伊春市",
            "value": "230700"
        },
        {
            "province": "黑龙江省",
            "label": "佳木斯市",
            "value": "230800"
        },
        {
            "province": "黑龙江省",
            "label": "七台河市",
            "value": "230900"
        },
        {
            "province": "黑龙江省",
            "label": "牡丹江市",
            "value": "231000"
        },
        {
            "province": "黑龙江省",
            "label": "黑河市",
            "value": "231100"
        },
        {
            "province": "黑龙江省",
            "label": "绥化市",
            "value": "231200"
        },
        {
            "province": "黑龙江省",
            "label": "大兴安岭地区",
            "value": "232700"
        }
    ]},
    {
    "value": "310000",
    "label": "上海市",
    "children": [
        {
            "province": "上海市",
            "label": "上海市",
            "value": "310100"
        }
    ]},
    {
    "value": "320000",
    "label": "江苏省",
    "children": [
        {
            "province": "江苏省",
            "label": "南京市",
            "value": "320100"
        },
        {
            "province": "江苏省",
            "label": "无锡市",
            "value": "320200"
        },
        {
            "province": "江苏省",
            "label": "徐州市",
            "value": "320300"
        },
        {
            "province": "江苏省",
            "label": "常州市",
            "value": "320400"
        },
        {
            "province": "江苏省",
            "label": "苏州市",
            "value": "320500"
        },
        {
            "province": "江苏省",
            "label": "南通市",
            "value": "320600"
        },
        {
            "province": "江苏省",
            "label": "连云港市",
            "value": "320700"
        },
        {
            "province": "江苏省",
            "label": "淮安市",
            "value": "320800"
        },
        {
            "province": "江苏省",
            "label": "盐城市",
            "value": "320900"
        },
        {
            "province": "江苏省",
            "label": "扬州市",
            "value": "321000"
        },
        {
            "province": "江苏省",
            "label": "镇江市",
            "value": "321100"
        },
        {
            "province": "江苏省",
            "label": "泰州市",
            "value": "321200"
        },
        {
            "province": "江苏省",
            "label": "宿迁市",
            "value": "321300"
        }
    ]},
    {
    "value": "330000",
    "label": "浙江省",
    "children": [
        {
            "province": "浙江省",
            "label": "杭州市",
            "value": "330100"
        },
        {
            "province": "浙江省",
            "label": "宁波市",
            "value": "330200"
        },
        {
            "province": "浙江省",
            "label": "温州市",
            "value": "330300"
        },
        {
            "province": "浙江省",
            "label": "嘉兴市",
            "value": "330400"
        },
        {
            "province": "浙江省",
            "label": "湖州市",
            "value": "330500"
        },
        {
            "province": "浙江省",
            "label": "绍兴市",
            "value": "330600"
        },
        {
            "province": "浙江省",
            "label": "金华市",
            "value": "330700"
        },
        {
            "province": "浙江省",
            "label": "衢州市",
            "value": "330800"
        },
        {
            "province": "浙江省",
            "label": "舟山市",
            "value": "330900"
        },
        {
            "province": "浙江省",
            "label": "台州市",
            "value": "331000"
        },
        {
            "province": "浙江省",
            "label": "丽水市",
            "value": "331100"
        }
    ]},
    {
    "value": "340000",
    "label": "安徽省",
    "children": [
        {
            "province": "安徽省",
            "label": "合肥市",
            "value": "340100"
        },
        {
            "province": "安徽省",
            "label": "芜湖市",
            "value": "340200"
        },
        {
            "province": "安徽省",
            "label": "蚌埠市",
            "value": "340300"
        },
        {
            "province": "安徽省",
            "label": "淮南市",
            "value": "340400"
        },
        {
            "province": "安徽省",
            "label": "马鞍山市",
            "value": "340500"
        },
        {
            "province": "安徽省",
            "label": "淮北市",
            "value": "340600"
        },
        {
            "province": "安徽省",
            "label": "铜陵市",
            "value": "340700"
        },
        {
            "province": "安徽省",
            "label": "安庆市",
            "value": "340800"
        },
        {
            "province": "安徽省",
            "label": "黄山市",
            "value": "341000"
        },
        {
            "province": "安徽省",
            "label": "滁州市",
            "value": "341100"
        },
        {
            "province": "安徽省",
            "label": "阜阳市",
            "value": "341200"
        },
        {
            "province": "安徽省",
            "label": "宿州市",
            "value": "341300"
        },
        {
            "province": "安徽省",
            "label": "六安市",
            "value": "341500"
        },
        {
            "province": "安徽省",
            "label": "亳州市",
            "value": "341600"
        },
        {
            "province": "安徽省",
            "label": "池州市",
            "value": "341700"
        },
        {
            "province": "安徽省",
            "label": "宣城市",
            "value": "341800"
        }
    ]},
    {
    "value": "350000",
    "label": "福建省",
    "children": [
        {
            "province": "福建省",
            "label": "福州市",
            "value": "350100"
        },
        {
            "province": "福建省",
            "label": "厦门市",
            "value": "350200"
        },
        {
            "province": "福建省",
            "label": "莆田市",
            "value": "350300"
        },
        {
            "province": "福建省",
            "label": "三明市",
            "value": "350400"
        },
        {
            "province": "福建省",
            "label": "泉州市",
            "value": "350500"
        },
        {
            "province": "福建省",
            "label": "漳州市",
            "value": "350600"
        },
        {
            "province": "福建省",
            "label": "南平市",
            "value": "350700"
        },
        {
            "province": "福建省",
            "label": "龙岩市",
            "value": "350800"
        },
        {
            "province": "福建省",
            "label": "宁德市",
            "value": "350900"
        }
    ]},
    {
    "value": "360000",
    "label": "江西省",
    "children": [
        {
            "province": "江西省",
            "label": "南昌市",
            "value": "360100"
        },
        {
            "province": "江西省",
            "label": "景德镇市",
            "value": "360200"
        },
        {
            "province": "江西省",
            "label": "萍乡市",
            "value": "360300"
        },
        {
            "province": "江西省",
            "label": "九江市",
            "value": "360400"
        },
        {
            "province": "江西省",
            "label": "新余市",
            "value": "360500"
        },
        {
            "province": "江西省",
            "label": "鹰潭市",
            "value": "360600"
        },
        {
            "province": "江西省",
            "label": "赣州市",
            "value": "360700"
        },
        {
            "province": "江西省",
            "label": "吉安市",
            "value": "360800"
        },
        {
            "province": "江西省",
            "label": "宜春市",
            "value": "360900"
        },
        {
            "province": "江西省",
            "label": "抚州市",
            "value": "361000"
        },
        {
            "province": "江西省",
            "label": "上饶市",
            "value": "361100"
        }
    ]},
    {
    "value": "370000",
    "label": "山东省",
    "children": [
        {
            "province": "山东省",
            "label": "济南市",
            "value": "370100"
        },
        {
            "province": "山东省",
            "label": "青岛市",
            "value": "370200"
        },
        {
            "province": "山东省",
            "label": "淄博市",
            "value": "370300"
        },
        {
            "province": "山东省",
            "label": "枣庄市",
            "value": "370400"
        },
        {
            "province": "山东省",
            "label": "东营市",
            "value": "370500"
        },
        {
            "province": "山东省",
            "label": "烟台市",
            "value": "370600"
        },
        {
            "province": "山东省",
            "label": "潍坊市",
            "value": "370700"
        },
        {
            "province": "山东省",
            "label": "济宁市",
            "value": "370800"
        },
        {
            "province": "山东省",
            "label": "泰安市",
            "value": "370900"
        },
        {
            "province": "山东省",
            "label": "威海市",
            "value": "371000"
        },
        {
            "province": "山东省",
            "label": "日照市",
            "value": "371100"
        },
        {
            "province": "山东省",
            "label": "莱芜市",
            "value": "371200"
        },
        {
            "province": "山东省",
            "label": "临沂市",
            "value": "371300"
        },
        {
            "province": "山东省",
            "label": "德州市",
            "value": "371400"
        },
        {
            "province": "山东省",
            "label": "聊城市",
            "value": "371500"
        },
        {
            "province": "山东省",
            "label": "滨州市",
            "value": "371600"
        },
        {
            "province": "山东省",
            "label": "菏泽市",
            "value": "371700"
        }
    ]},
    {
    "value": "410000",
    "label": "河南省",
    "children": [
        {
            "province": "河南省",
            "label": "郑州市",
            "value": "410100"
        },
        {
            "province": "河南省",
            "label": "开封市",
            "value": "410200"
        },
        {
            "province": "河南省",
            "label": "洛阳市",
            "value": "410300"
        },
        {
            "province": "河南省",
            "label": "平顶山市",
            "value": "410400"
        },
        {
            "province": "河南省",
            "label": "安阳市",
            "value": "410500"
        },
        {
            "province": "河南省",
            "label": "鹤壁市",
            "value": "410600"
        },
        {
            "province": "河南省",
            "label": "新乡市",
            "value": "410700"
        },
        {
            "province": "河南省",
            "label": "焦作市",
            "value": "410800"
        },
        {
            "province": "河南省",
            "label": "濮阳市",
            "value": "410900"
        },
        {
            "province": "河南省",
            "label": "许昌市",
            "value": "411000"
        },
        {
            "province": "河南省",
            "label": "漯河市",
            "value": "411100"
        },
        {
            "province": "河南省",
            "label": "三门峡市",
            "value": "411200"
        },
        {
            "province": "河南省",
            "label": "南阳市",
            "value": "411300"
        },
        {
            "province": "河南省",
            "label": "商丘市",
            "value": "411400"
        },
        {
            "province": "河南省",
            "label": "信阳市",
            "value": "411500"
        },
        {
            "province": "河南省",
            "label": "周口市",
            "value": "411600"
        },
        {
            "province": "河南省",
            "label": "驻马店市",
            "value": "411700"
        },
        {
            "province": "河南省",
            "label": "省直辖县级行政区划",
            "value": "419000"
        }
    ]},
    {
    "value": "420000",
    "label": "湖北省",
    "children": [
        {
            "province": "湖北省",
            "label": "武汉市",
            "value": "420100"
        },
        {
            "province": "湖北省",
            "label": "黄石市",
            "value": "420200"
        },
        {
            "province": "湖北省",
            "label": "十堰市",
            "value": "420300"
        },
        {
            "province": "湖北省",
            "label": "宜昌市",
            "value": "420500"
        },
        {
            "province": "湖北省",
            "label": "襄阳市",
            "value": "420600"
        },
        {
            "province": "湖北省",
            "label": "鄂州市",
            "value": "420700"
        },
        {
            "province": "湖北省",
            "label": "荆门市",
            "value": "420800"
        },
        {
            "province": "湖北省",
            "label": "孝感市",
            "value": "420900"
        },
        {
            "province": "湖北省",
            "label": "荆州市",
            "value": "421000"
        },
        {
            "province": "湖北省",
            "label": "黄冈市",
            "value": "421100"
        },
        {
            "province": "湖北省",
            "label": "咸宁市",
            "value": "421200"
        },
        {
            "province": "湖北省",
            "label": "随州市",
            "value": "421300"
        },
        {
            "province": "湖北省",
            "label": "恩施土家族苗族自治州",
            "value": "422800"
        },
        {
            "province": "湖北省",
            "label": "省直辖县级行政区划",
            "value": "429000"
        }
    ]},
    {
    "value": "430000",
    "label": "湖南省",
    "children": [
        {
            "province": "湖南省",
            "label": "长沙市",
            "value": "430100"
        },
        {
            "province": "湖南省",
            "label": "株洲市",
            "value": "430200"
        },
        {
            "province": "湖南省",
            "label": "湘潭市",
            "value": "430300"
        },
        {
            "province": "湖南省",
            "label": "衡阳市",
            "value": "430400"
        },
        {
            "province": "湖南省",
            "label": "邵阳市",
            "value": "430500"
        },
        {
            "province": "湖南省",
            "label": "岳阳市",
            "value": "430600"
        },
        {
            "province": "湖南省",
            "label": "常德市",
            "value": "430700"
        },
        {
            "province": "湖南省",
            "label": "张家界市",
            "value": "430800"
        },
        {
            "province": "湖南省",
            "label": "益阳市",
            "value": "430900"
        },
        {
            "province": "湖南省",
            "label": "郴州市",
            "value": "431000"
        },
        {
            "province": "湖南省",
            "label": "永州市",
            "value": "431100"
        },
        {
            "province": "湖南省",
            "label": "怀化市",
            "value": "431200"
        },
        {
            "province": "湖南省",
            "label": "娄底市",
            "value": "431300"
        },
        {
            "province": "湖南省",
            "label": "湘西土家族苗族自治州",
            "value": "433100"
        }
    ]},
    {
    "value": "440000",
    "label": "广东省",
    "children": [
        {
            "province": "广东省",
            "label": "广州市",
            "value": "440100"
        },
        {
            "province": "广东省",
            "label": "韶关市",
            "value": "440200"
        },
        {
            "province": "广东省",
            "label": "深圳市",
            "value": "440300"
        },
        {
            "province": "广东省",
            "label": "珠海市",
            "value": "440400"
        },
        {
            "province": "广东省",
            "label": "汕头市",
            "value": "440500"
        },
        {
            "province": "广东省",
            "label": "佛山市",
            "value": "440600"
        },
        {
            "province": "广东省",
            "label": "江门市",
            "value": "440700"
        },
        {
            "province": "广东省",
            "label": "湛江市",
            "value": "440800"
        },
        {
            "province": "广东省",
            "label": "茂名市",
            "value": "440900"
        },
        {
            "province": "广东省",
            "label": "肇庆市",
            "value": "441200"
        },
        {
            "province": "广东省",
            "label": "惠州市",
            "value": "441300"
        },
        {
            "province": "广东省",
            "label": "梅州市",
            "value": "441400"
        },
        {
            "province": "广东省",
            "label": "汕尾市",
            "value": "441500"
        },
        {
            "province": "广东省",
            "label": "河源市",
            "value": "441600"
        },
        {
            "province": "广东省",
            "label": "阳江市",
            "value": "441700"
        },
        {
            "province": "广东省",
            "label": "清远市",
            "value": "441800"
        },
        {
            "province": "广东省",
            "label": "东莞市",
            "value": "441900"
        },
        {
            "province": "广东省",
            "label": "中山市",
            "value": "442000"
        },
        {
            "province": "广东省",
            "label": "潮州市",
            "value": "445100"
        },
        {
            "province": "广东省",
            "label": "揭阳市",
            "value": "445200"
        },
        {
            "province": "广东省",
            "label": "云浮市",
            "value": "445300"
        }
    ]},
    {
    "value": "450000",
    "label": "广西壮族自治区",
    "children": [
        {
            "province": "广西壮族自治区",
            "label": "南宁市",
            "value": "450100"
        },
        {
            "province": "广西壮族自治区",
            "label": "柳州市",
            "value": "450200"
        },
        {
            "province": "广西壮族自治区",
            "label": "桂林市",
            "value": "450300"
        },
        {
            "province": "广西壮族自治区",
            "label": "梧州市",
            "value": "450400"
        },
        {
            "province": "广西壮族自治区",
            "label": "北海市",
            "value": "450500"
        },
        {
            "province": "广西壮族自治区",
            "label": "防城港市",
            "value": "450600"
        },
        {
            "province": "广西壮族自治区",
            "label": "钦州市",
            "value": "450700"
        },
        {
            "province": "广西壮族自治区",
            "label": "贵港市",
            "value": "450800"
        },
        {
            "province": "广西壮族自治区",
            "label": "玉林市",
            "value": "450900"
        },
        {
            "province": "广西壮族自治区",
            "label": "百色市",
            "value": "451000"
        },
        {
            "province": "广西壮族自治区",
            "label": "贺州市",
            "value": "451100"
        },
        {
            "province": "广西壮族自治区",
            "label": "河池市",
            "value": "451200"
        },
        {
            "province": "广西壮族自治区",
            "label": "来宾市",
            "value": "451300"
        },
        {
            "province": "广西壮族自治区",
            "label": "崇左市",
            "value": "451400"
        }
    ]},
    {
    "value": "460000",
    "label": "海南省",
    "children": [
        {
            "province": "海南省",
            "label": "海口市",
            "value": "460100"
        },
        {
            "province": "海南省",
            "label": "三亚市",
            "value": "460200"
        },
        {
            "province": "海南省",
            "label": "三沙市",
            "value": "460300"
        },
        {
            "province": "海南省",
            "label": "儋州市",
            "value": "460400"
        },
        {
            "province": "海南省",
            "label": "省直辖县级行政区划",
            "value": "469000"
        }
    ]},
    {
    "value": "500000",
    "label": "重庆市",
    "children": [
        {
            "province": "重庆市",
            "label": "重庆市",
            "value": "500100"
        }
    ]},
    {
    "value": "510000",
    "label": "四川省",
    "children": [
        {
            "province": "四川省",
            "label": "成都市",
            "value": "510100"
        },
        {
            "province": "四川省",
            "label": "自贡市",
            "value": "510300"
        },
        {
            "province": "四川省",
            "label": "攀枝花市",
            "value": "510400"
        },
        {
            "province": "四川省",
            "label": "泸州市",
            "value": "510500"
        },
        {
            "province": "四川省",
            "label": "德阳市",
            "value": "510600"
        },
        {
            "province": "四川省",
            "label": "绵阳市",
            "value": "510700"
        },
        {
            "province": "四川省",
            "label": "广元市",
            "value": "510800"
        },
        {
            "province": "四川省",
            "label": "遂宁市",
            "value": "510900"
        },
        {
            "province": "四川省",
            "label": "内江市",
            "value": "511000"
        },
        {
            "province": "四川省",
            "label": "乐山市",
            "value": "511100"
        },
        {
            "province": "四川省",
            "label": "南充市",
            "value": "511300"
        },
        {
            "province": "四川省",
            "label": "眉山市",
            "value": "511400"
        },
        {
            "province": "四川省",
            "label": "宜宾市",
            "value": "511500"
        },
        {
            "province": "四川省",
            "label": "广安市",
            "value": "511600"
        },
        {
            "province": "四川省",
            "label": "达州市",
            "value": "511700"
        },
        {
            "province": "四川省",
            "label": "雅安市",
            "value": "511800"
        },
        {
            "province": "四川省",
            "label": "巴中市",
            "value": "511900"
        },
        {
            "province": "四川省",
            "label": "资阳市",
            "value": "512000"
        },
        {
            "province": "四川省",
            "label": "阿坝藏族羌族自治州",
            "value": "513200"
        },
        {
            "province": "四川省",
            "label": "甘孜藏族自治州",
            "value": "513300"
        },
        {
            "province": "四川省",
            "label": "凉山彝族自治州",
            "value": "513400"
        }
    ]},
    {
    "value": "520000",
    "label": "贵州省",
    "children": [
        {
            "province": "贵州省",
            "label": "贵阳市",
            "value": "520100"
        },
        {
            "province": "贵州省",
            "label": "六盘水市",
            "value": "520200"
        },
        {
            "province": "贵州省",
            "label": "遵义市",
            "value": "520300"
        },
        {
            "province": "贵州省",
            "label": "安顺市",
            "value": "520400"
        },
        {
            "province": "贵州省",
            "label": "毕节市",
            "value": "520500"
        },
        {
            "province": "贵州省",
            "label": "铜仁市",
            "value": "520600"
        },
        {
            "province": "贵州省",
            "label": "黔西南布依族苗族自治州",
            "value": "522300"
        },
        {
            "province": "贵州省",
            "label": "黔东南苗族侗族自治州",
            "value": "522600"
        },
        {
            "province": "贵州省",
            "label": "黔南布依族苗族自治州",
            "value": "522700"
        }
    ]},
    {
    "value": "530000",
    "label": "云南省",
    "children": [
        {
            "province": "云南省",
            "label": "昆明市",
            "value": "530100"
        },
        {
            "province": "云南省",
            "label": "曲靖市",
            "value": "530300"
        },
        {
            "province": "云南省",
            "label": "玉溪市",
            "value": "530400"
        },
        {
            "province": "云南省",
            "label": "保山市",
            "value": "530500"
        },
        {
            "province": "云南省",
            "label": "昭通市",
            "value": "530600"
        },
        {
            "province": "云南省",
            "label": "丽江市",
            "value": "530700"
        },
        {
            "province": "云南省",
            "label": "普洱市",
            "value": "530800"
        },
        {
            "province": "云南省",
            "label": "临沧市",
            "value": "530900"
        },
        {
            "province": "云南省",
            "label": "楚雄彝族自治州",
            "value": "532300"
        },
        {
            "province": "云南省",
            "label": "红河哈尼族彝族自治州",
            "value": "532500"
        },
        {
            "province": "云南省",
            "label": "文山壮族苗族自治州",
            "value": "532600"
        },
        {
            "province": "云南省",
            "label": "西双版纳傣族自治州",
            "value": "532800"
        },
        {
            "province": "云南省",
            "label": "大理白族自治州",
            "value": "532900"
        },
        {
            "province": "云南省",
            "label": "德宏傣族景颇族自治州",
            "value": "533100"
        },
        {
            "province": "云南省",
            "label": "怒江傈僳族自治州",
            "value": "533300"
        },
        {
            "province": "云南省",
            "label": "迪庆藏族自治州",
            "value": "533400"
        }
    ]},
    {
    "value": "540000",
    "label": "西藏自治区",
    "children": [
        {
            "province": "西藏自治区",
            "label": "拉萨市",
            "value": "540100"
        },
        {
            "province": "西藏自治区",
            "label": "日喀则市",
            "value": "540200"
        },
        {
            "province": "西藏自治区",
            "label": "昌都市",
            "value": "540300"
        },
        {
            "province": "西藏自治区",
            "label": "林芝市",
            "value": "540400"
        },
        {
            "province": "西藏自治区",
            "label": "山南市",
            "value": "540500"
        },
        {
            "province": "西藏自治区",
            "label": "那曲地区",
            "value": "542400"
        },
        {
            "province": "西藏自治区",
            "label": "阿里地区",
            "value": "542500"
        }
    ]},
    {
    "value": "610000",
    "label": "陕西省",
    "children": [
        {
            "province": "陕西省",
            "label": "西安市",
            "value": "610100"
        },
        {
            "province": "陕西省",
            "label": "铜川市",
            "value": "610200"
        },
        {
            "province": "陕西省",
            "label": "宝鸡市",
            "value": "610300"
        },
        {
            "province": "陕西省",
            "label": "咸阳市",
            "value": "610400"
        },
        {
            "province": "陕西省",
            "label": "渭南市",
            "value": "610500"
        },
        {
            "province": "陕西省",
            "label": "延安市",
            "value": "610600"
        },
        {
            "province": "陕西省",
            "label": "汉中市",
            "value": "610700"
        },
        {
            "province": "陕西省",
            "label": "榆林市",
            "value": "610800"
        },
        {
            "province": "陕西省",
            "label": "安康市",
            "value": "610900"
        },
        {
            "province": "陕西省",
            "label": "商洛市",
            "value": "611000"
        }
    ]},
    {
    "value": "620000",
    "label": "甘肃省",
    "children": [
        {
            "province": "甘肃省",
            "label": "兰州市",
            "value": "620100"
        },
        {
            "province": "甘肃省",
            "label": "嘉峪关市",
            "value": "620200"
        },
        {
            "province": "甘肃省",
            "label": "金昌市",
            "value": "620300"
        },
        {
            "province": "甘肃省",
            "label": "白银市",
            "value": "620400"
        },
        {
            "province": "甘肃省",
            "label": "天水市",
            "value": "620500"
        },
        {
            "province": "甘肃省",
            "label": "武威市",
            "value": "620600"
        },
        {
            "province": "甘肃省",
            "label": "张掖市",
            "value": "620700"
        },
        {
            "province": "甘肃省",
            "label": "平凉市",
            "value": "620800"
        },
        {
            "province": "甘肃省",
            "label": "酒泉市",
            "value": "620900"
        },
        {
            "province": "甘肃省",
            "label": "庆阳市",
            "value": "621000"
        },
        {
            "province": "甘肃省",
            "label": "定西市",
            "value": "621100"
        },
        {
            "province": "甘肃省",
            "label": "陇南市",
            "value": "621200"
        },
        {
            "province": "甘肃省",
            "label": "临夏回族自治州",
            "value": "622900"
        },
        {
            "province": "甘肃省",
            "label": "甘南藏族自治州",
            "value": "623000"
        }
    ]},
    {
    "value": "630000",
    "label": "青海省",
    "children": [
        {
            "province": "青海省",
            "label": "西宁市",
            "value": "630100"
        },
        {
            "province": "青海省",
            "label": "海东市",
            "value": "630200"
        },
        {
            "province": "青海省",
            "label": "海北藏族自治州",
            "value": "632200"
        },
        {
            "province": "青海省",
            "label": "黄南藏族自治州",
            "value": "632300"
        },
        {
            "province": "青海省",
            "label": "海南藏族自治州",
            "value": "632500"
        },
        {
            "province": "青海省",
            "label": "果洛藏族自治州",
            "value": "632600"
        },
        {
            "province": "青海省",
            "label": "玉树藏族自治州",
            "value": "632700"
        },
        {
            "province": "青海省",
            "label": "海西蒙古族藏族自治州",
            "value": "632800"
        }
    ]},
    {
    "value": "640000",
    "label": "宁夏回族自治区",
    "children": [
        {
            "province": "宁夏回族自治区",
            "label": "银川市",
            "value": "640100"
        },
        {
            "province": "宁夏回族自治区",
            "label": "石嘴山市",
            "value": "640200"
        },
        {
            "province": "宁夏回族自治区",
            "label": "吴忠市",
            "value": "640300"
        },
        {
            "province": "宁夏回族自治区",
            "label": "固原市",
            "value": "640400"
        },
        {
            "province": "宁夏回族自治区",
            "label": "中卫市",
            "value": "640500"
        }
    ]},
    {
    "value": "650000",
    "label": "新疆维吾尔自治区",
    "children": [
        {
            "province": "新疆维吾尔自治区",
            "label": "乌鲁木齐市",
            "value": "650100"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "克拉玛依市",
            "value": "650200"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "吐鲁番市",
            "value": "650400"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "哈密市",
            "value": "650500"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "昌吉回族自治州",
            "value": "652300"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "博尔塔拉蒙古自治州",
            "value": "652700"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "巴音郭楞蒙古自治州",
            "value": "652800"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "阿克苏地区",
            "value": "652900"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "克孜勒苏柯尔克孜自治州",
            "value": "653000"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "喀什地区",
            "value": "653100"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "和田地区",
            "value": "653200"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "伊犁哈萨克自治州",
            "value": "654000"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "塔城地区",
            "value": "654200"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "阿勒泰地区",
            "value": "654300"
        },
        {
            "province": "新疆维吾尔自治区",
            "label": "自治区直辖县级行政区划",
            "value": "659000"
        }
    ]}
]
export default city


// WEBPACK FOOTER //
// ./src/components/city.js